define('v3/Common/Services/Frontend/EmptyPlaceholder.Service',[
	'jquery'
], function ($) {
	var defaults = {
		loader: '#loader-container .loader',
		template:	'<div class="empty placeholder" data-bind="stopBinding: {}">' +
						'<div class="instruction-msg grid">' +
							Strings.NoDataToShow +
						'</div>' +
					'</div>',
		appendTo: $('.main > div:not(.tab-container)'),
		defaultAppendTo: '.main > div:not(.tab-container)'
	};

	return {
		show: function (elm) {
			var $elm = $(elm);
			if ($elm.children('.empty.placeholder').length === 0) {
				$(defaults.template).appendTo($elm);
			}
		},
		hide: function (elm) {
			$(elm).children('.empty.placeholder').remove();
		}
	};
});

